import { HttpClient } from '@angular/common/http';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var BPGAdminHomeService = /** @class */ (function () {
    function BPGAdminHomeService(http, bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
        this.URI = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.homePageDataApi = ConstantValues.userManagementApiUrl.getHomePageData;
        this.adminsChapterDetailsApi = ConstantValues.userManagementApiUrl.getAdminsChatperData;
    }
    /** For service call to get bpg news list
 * @class DiHomePageService
 * @method getDiNewsList
 * @param landingData
 * @returns Observable
 **/
    BPGAdminHomeService.prototype.getHomeData = function (ChapterExistsDTO) {
        return this.http.post(this.URI + this.homePageDataApi, ChapterExistsDTO, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    BPGAdminHomeService.prototype.getChapterData = function () {
        return this.http.get(this.URI + this.adminsChapterDetailsApi, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    BPGAdminHomeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BPGAdminHomeService_Factory() { return new BPGAdminHomeService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: BPGAdminHomeService, providedIn: "root" });
    return BPGAdminHomeService;
}());
export { BPGAdminHomeService };
